import { AuthAction } from '../actions';
import { AuthActionType } from '../actionTypes';
import { User } from '../types';

interface AuthState {
    currentUser: User | null;
    loading: boolean;
}

const INITIAL_STATE: AuthState = {
    currentUser: null,
    loading: true,
};

const authReducer = (state: AuthState = INITIAL_STATE, action: AuthAction) => {
    switch (action.type) {
        case AuthActionType.GET_CURRENT_USER: {
            return {
                ...state,
                currentUser: action.payload,
                loading: false,
            };
        }
        case AuthActionType.SUPERVISOR_CAPACITY_UPDATE: {
            const updatedSupervisor = (action.payload as { supervisor: User })
                .supervisor;

            if (!updatedSupervisor) {
                return state;
            }
            if (updatedSupervisor._id !== state.currentUser?._id) {
                return state;
            }

            return {
                ...state,
                currentUser: {
                    ...state.currentUser,
                    projectsSupervisionCapacity:
                        updatedSupervisor.projectsSupervisionCapacity,
                },
            };
        }
        case AuthActionType.UPDATE_CURRENT_USER_UNREAD_TOPIC_MESSAGES: {
            return {
                ...state,
                currentUser: action.payload,
            };
        }
        default:
            return state;
    }
};

export default authReducer;
